export default "__VITE_ASSET__CWnl5KfT__"